// extracted by mini-css-extract-plugin
module.exports = {"form-iterator":"styles_form-iterator__34ZRt","total-score_error":"styles_total-score_error__3crKy","form-data-consumer":"styles_form-data-consumer__12ss4"};